var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinusAlt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10C16.5 10.5625 16.0312 11 15.5 11H4.5C3.9375 11 3.5 10.5625 3.5 10C3.5 9.46875 3.9375 9 4.5 9H15.5C16.0312 9 16.5 9.46875 16.5 10Z",
    fill: "#273546"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusAlt);
export default __webpack_public_path__ + "static/media/minus_alt.09e9c25acd206e9d2fde8a40ee9328aa.svg";
export { ForwardRef as ReactComponent };